import type { EnvironmentId, ServerConfig } from "@t3tools/contracts";

import { usePrimaryEnvironmentId } from "../environments/primary";
import { useSavedEnvironmentRuntimeStore } from "../environments/runtime";
import { useServerConfig } from "../rpc/serverState";

export function useEnvironmentServerConfig(
  environmentId: EnvironmentId | null | undefined,
): ServerConfig | null {
  const primaryEnvironmentId = usePrimaryEnvironmentId();
  const primaryServerConfig = useServerConfig();
  const savedServerConfig = useSavedEnvironmentRuntimeStore((state) =>
    environmentId ? (state.byId[environmentId]?.serverConfig ?? null) : null,
  );
  return primaryEnvironmentId !== null && environmentId === primaryEnvironmentId
    ? primaryServerConfig
    : (savedServerConfig ?? primaryServerConfig);
}
